import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase'


import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

Vue.config.productionTip = false

Vue.component('v-menu', require('./components/menu').default)
Vue.component('v-cover', require('./components/cover').default)
Vue.component('v-streak', require('./components/streak').default)
Vue.component('v-info', require('./components/info').default)
Vue.component('v-parallax', require('./components/parallax').default)
Vue.component('v-cards', require('./components/cards').default)
Vue.component('v-map', require('./components/map').default)
Vue.component('v-carousel', require('./components/carousel').default)
Vue.component('v-login', require('./components/login').default)
Vue.component('v-estimate', require('./components/estimateModal').default)

const config = {
    apiKey: "AIzaSyBHXvRoZjucyn09jSvqqgBCverAoy2lTRg",
    authDomain: "imprenta-las-americas.firebaseapp.com",
    databaseURL: "https://imprenta-las-americas.firebaseio.com",
    projectId: "imprenta-las-americas",
    storageBucket: "imprenta-las-americas.appspot.com",
    messagingSenderId: "597700930856",
    appId: "1:597700930856:web:71f84651651a778d03f41d",
    measurementId: "G-JHDT1KBP1X"
};

firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
        store.commit('logged', true)

    } else {
        store.commit('logged', false)
    }
})

var storageRef = firebase.storage().ref();
var listRef = storageRef.child('images');
listRef.listAll().then(function(result) {
    console.log(result);
    result.items.forEach(function(imgRef) {
        imgRef.getDownloadURL().then(function(url) {
            store.commit('getImages', url)
        })
    })
}).catch(function(error) {
    console.log(error);
});

new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')















// Just in case

// var img = $('<img />').attr({
//     'id': 'poster' + img_index,
//     'src': url,
//     'alt': 'image',
//     'title': 'image',
//     'width': 250
// }).appendTo('#img-area');

//     img_index++;
// });